export enum StepTypeEnum {
  custom_component = 'custom_component',
  terms_and_conditions = 'terms_and_conditions',
  form = 'form',
  text = 'text',
}
